export default __webpack_public_path__ + "static/Sash-4-5191341036f1b2e089a15c2ad220b928.png";